import { ShellBridgeStore } from './ShellBridgeStore';
import { ShellEventBus } from './ShellEventBus';

/** Singleton store — shared across all shell components that consume contributions */
export const shellBridgeStore = new ShellBridgeStore();

/** Singleton event bus — shell emits events, apps subscribe via their bridge */
export const shellEventBus = new ShellEventBus();
